import { FC } from 'react';

import { ImagesApp } from '../../constants/images';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import * as Style from './styles.tags';

const OGlobo: FC = () => {
  const { translate } = useI18nContext();

  return (
    <Style.OGlobo id="o-globo-tag">
      <img id="o-globo-tag-image" src={ImagesApp.svg.oGlobo} alt="Letra G" />
      <span id="o-globo-tag-text">{translate(['TAGS', 'O_GLOBO'])}</span>
    </Style.OGlobo>
  );
};

export default OGlobo;
